import { listToast, status } from "@/constants";
import { setItem, setToast, ToggleLoading } from "@/redux/features";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { MenuProvider } from "./context/menucontext";
import MenuSidebar from "./MenuSidebar";
import { Dropdownz } from "@/components/data_table/FormList";
import { useGetTotalNotice, useListProject } from "./utils";
import { useUserInfo } from "@/axios/utils";
import { Badge } from "@/uiCore";
import { useListCountMess, useListMessage } from "@/modules/message/utils";
import avatar from "@/image/no_avatar.jpg";
import { routes } from "@/routes";

const handleTreeSelect = (data) => {
  let newData = [];
  if (data && data[0]) {
    newData = data.map((d) => {
      const children =
        d.buildings && d.buildings[0]
          ? d.buildings.map((b) => {
              return {
                key: d.id + "-" + b.id,
                label: b.name,
                icon: "pi pi-building",
              };
            })
          : [];
      return { key: d.id + "", label: d.name, children };
    });
  }
  return newData;
};

const HeaderSideBar = (props) => {
  const { data, setVisible, item, setModel } = props;
  const [selectedNodeKey, setSelectedNodeKey] = useState(() => {
    return item.building_id
      ? item.company_id + "-" + item.building_id
      : item.company_id;
  });
  const [infos, setInfos] = useState();
  useEffect(() => {
    if (item) {
      setInfos(item);
    }
  }, [item]);

  useEffect(() => {}, []);

  const user_info = useUserInfo();
  return (
    <div className="header-sidebar">
      <div className="w-11 grid grid-form align-item-center  mt-4 mx-auto shadow-4 border-round-md">
        <div className="col-4 text-right cursor-pointer">
          <img
            src={avatar}
            height="48px"
            width="48px"
            alt="Ảnh đại diện"
            style={{ borderRadius: "50%", border: "4px solid #e9ecef" }}
          ></img>
        </div>
        <div className="col-8 text-left text-ellipsis">
          <b>
            {user_info?.data?.ub_title
              ? user_info?.data?.ub_title
              : "user" + user_info?.data?.id}
          </b>
          <div className="mt-1">
            <i
              className="pi pi-circle-fill mr-2"
              style={{ color: "#28a745" }}
            />
            <b>Online</b>
          </div>
        </div>
      </div>
    </div>
  );
};

const AppSidebar = ({ setVisible }) => {
  const dispatch = useDispatch();
  const myTool = useSelector((state) => state.myTool) || {};
  const item = useSelector((state) => state.item) || {};
  const [params, setParams] = useState({});
  const location = useLocation();
  const [data, setData] = useState();
  const data_project = useListProject();
  const [model, setModel] = useState();
  const notice = useGetTotalNotice({ params });
  useEffect(() => {
    if (data_project) {
      setModel([
        {
          children: [
            {
              name: "Trang chủ",
              icon: "pi pi-home",
              children: [{ name: "Trang chủ", route: "/" }],
            },
            {
              name: "Quản lý dự án",
              icon: "pi pi-check-square",
              children: [
                {
                  name: "Quản lý khách hàng",
                  route: "/divide",
                },
                {
                  name: "Quản lý Facebook ADS",
                  route: "/page_list",
                },
                {
                  name: "Quản lý Google ADS",
                  route: "/sheet_list",
                },
                {
                  name: "Quản lý Zalo ADS",
                  route: "/zalo_list",
                },
                {
                  name: "Phân bổ lịch Dự án Facebook",
                  route: "/project_list",
                },
              ],
            },
            {
              name: "Báo cáo",
              icon: "pi pi-chart-bar",
              children: [
                { name: "Báo cáo tổng quát", route: "/report" },
                { name: "Báo cáo theo ngày", route: "/report_day" },
                { name: "Báo cáo theo Dự án", route: "/report_project" },
              ],
            },
            {
              name: "Tra cứu",
              icon: "pi pi-search",
              children: [
                {
                  name: "Tra cứu sàn thuộc nhóm dự án",
                  route: "/search_department",
                },
                {
                  name: "Tra cứu khách FB qua thời gian thực",
                  route: "/search_per_day",
                },
              ],
            },
            {
              name: "Bảng điều khiển",
              icon: "pi pi-search",
              children: [
                // {
                //   name: "Bảng điều khiển FB",
                //   route: "/dashboard_fb",
                //   badge: notice?.[0]?.total,
                // },
                // {
                //   name: "Tra cứu khách FB qua thời gian thực",
                //   route: "/search_per_day",
                // },
              ],
            },
            // {
            //   name: "Tổng quan dự án",
            //   icon: "pi pi-address-book",
            //   children: data_project?.map((e) => ({
            //     name: e?.name,
            //     route: "/project_overview",
            //     project: e,
            //   })),
            // },
          ],
        },
      ]);
    }
  }, [data_project]);
  const project = JSON.parse(localStorage.getItem("item"));
  let list_chat;
  list_chat = useListMessage({
    project_id: project?.project_id_ad,
    token: project?.access_token,
    status: undefined,
  });
  useEffect(() => {
    let title;
    const type = item.building_id ? "building" : "company";
    const newData = myTool.myMenuTool.filter((m) => m.type === type || !m.type);
    newData.forEach((nd) => {
      if (nd.children && nd.children[0]) {
        nd.children.forEach((ndc) => {
          if (
            location.pathname.includes(ndc.route + "/") ||
            location.pathname === ndc.route
          )
            title = ndc.name;
        });
      }
    });
    if (title) document.title = title;
  }, [location.pathname, myTool]);

  return (
    <MenuProvider>
      <HeaderSideBar
        item={item}
        setVisible={setVisible}
        data={data_project}
        setModel={setModel}
      />
      <ul className="layout-menu ">
        {model?.map((item, i) => {
          return <MenuSidebar item={item} root={true} index={i} key={i} />;
        })}
      </ul>
    </MenuProvider>
  );
};

export default AppSidebar;
